import React from 'react';
import { useSelector } from 'react-redux';
import firebase from '@config/firebase.config';
import styles from './Settings.module.scss';
import { textVariantsEnum, Text, fontWeightEnum } from '@/components/Text';
import { Button } from '@/components/Button';
import { addNotification, notificationStates } from '@components/Notification';
const database = firebase.firestore();
export const StealthModeModal = ({
  pendingStealthModeValue,
  onClose,
  setStealthMode,
}) => {
  const userProfile = useSelector((state) => state.auth.profile);
  const handleStealthModeConfirm = async () => {
    if (!userProfile?.activeCompany?.companyId) return;

    const newValue = pendingStealthModeValue;

    try {
      await database
        .collection('companyDatabase')
        .doc(userProfile.activeCompany.companyId)
        .set(
          {
            stealthMode: newValue,
          },
          { merge: true }
        );

      // Update localStorage cache
      const cacheKey = `stealthMode_${userProfile.activeCompany.companyId}`;
      localStorage.setItem(cacheKey, String(newValue));

      setStealthMode(newValue);
      onClose();

      addNotification({
        message: `Stealth mode ${
          newValue ? 'enabled' : 'disabled'
        } successfully`,
        level: notificationStates.success,
      });
    } catch (error) {
      console.error('Error updating stealthMode:', error);
      addNotification({
        message: 'Failed to update stealth mode',
        level: notificationStates.error,
      });
    }
  };

  return (
    <div className={styles.stealthModeModal}>
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Medium}
      >
        Confirm Stealth Mode Change
      </Text>
      <Text
        variant={textVariantsEnum.Text_xs}
        fontWeight={fontWeightEnum.Normal}
      >
        Are you sure you want to{' '}
        {pendingStealthModeValue ? 'enable' : 'disable'} stealth mode?
      </Text>
      <div className={styles.buttonsContainer}>
        <Button onClick={onClose} text="Cancel" />
        <Button onClick={handleStealthModeConfirm} text="Confirm" />
      </div>
    </div>
  );
};
